// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';


class CancelSession extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      data_uploaded: false,
      data_error: false,
      comment: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }


  componentDidMount() {
    console.log(this.state.id);
  }

  postDeletedFixture(data, props) {
    console.log(data);
    const url = `${getLocationOrigin()}/fixture_session/`+this.state.id+`/cancel_session/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'cancelled': 1,
                                          'comment': this.state.comment});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.Message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }
  handleChange(event) {
    const name = event.target.name;
    this.setState({comment: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log('Submit');
    this.postDeletedFixture(this.state.id, this.props);
    console.log('post');
    console.log(this.state);
  }

  render() {
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Cancel Session</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
              <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Comments
              </div>
              <div className="col-md-6 input-group">
                <textarea rows="4" cols="33" id="comments" name="comment" placeholder="Reason For session cancellation" onChange={this.handleChange}>
                {this.state.comment}
                </textarea>
              </div>
            </div>
            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Cancel Session" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default CancelSession;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/cancelSession/index.js